import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

// SERVICES
import { BehaviorSubject, Observable, Subscription, throwError } from 'rxjs';

import { environment } from '@app/env-service';
import { PaginationInterface } from '@app/interfaces/pagination.model';
import { BusinessAccountPriceOverridesInterface } from '@app/modules/pricing/interfaces/pricing.interface';

@Injectable({
  providedIn: 'root',
})
export class ClientSkuPriceOverrideService {
  private readonly _loading = new BehaviorSubject<boolean>(<boolean>false);
  private readonly _pagination = new BehaviorSubject<PaginationInterface>(
    <PaginationInterface>{},
  );
  private readonly _businessAccountPriceOverrides = new BehaviorSubject<
    BusinessAccountPriceOverridesInterface[]
  >(<BusinessAccountPriceOverridesInterface[]>[]);

  loading$ = this._loading.asObservable();
  pagination$ = this._pagination.asObservable();
  businessAccountPriceOverrides$ =
    this._businessAccountPriceOverrides.asObservable();

  constructor(private http :HttpClient) {}

  get(params ?:{ [param :string] :string | string[] }) :Subscription {
    this._loading.next(true);

    return this.http
      .get(`${environment.urlV2}/pricing/business-account-specific-prices`, {
        params,
      })
      .subscribe(
        (response :any) => {
          this._loading.next(false);
          this._businessAccountPriceOverrides.next(response.data);
          this._pagination.next(response.meta);
        },
        (response :any) => {
          this._loading.next(false);
          throwError(response.error);
        },
      );
  }

  createPriceOverride(
    priceOverride :BusinessAccountPriceOverridesInterface,
  ) :Observable<any> {
    const payload :any = {
      businessAccountId: priceOverride.businessAccountId,
      rfqId: priceOverride.rfqId,
      price: priceOverride.price,
    };

    return this.http.post(
      `${environment.urlV2}/pricing/business-account-specific-prices`,
      payload,
    );
  }

  updatePriceOverride(
    id :number,
    priceOverride :BusinessAccountPriceOverridesInterface,
  ) :Observable<any> {
    const payload :any = {
      businessAccountId: priceOverride.businessAccountId,
      rfqId: priceOverride.rfqId,
      price: priceOverride.price,
    };

    return this.http.put(
      `${environment.urlV2}/pricing/business-account-specific-prices/${id}`,
      payload,
    );
  }

  removePriceOverride(id :number) :Observable<any> {
    return this.http.delete(
      `${environment.urlV2}/pricing/business-account-specific-prices/${id}`,
    );
  }

  getSkuPriceOverrideClients(params :{
    [param :string] :string | string[];
  }) :Observable<any> {
    const rfqId = params.rfqId;
    delete params.rfqId;

    return this.http.get(
      `${environment.urlV2}/pricing/business-account-specific-prices/sku-clients/${rfqId}`,
      { params: params },
    );
  }
}
